import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#050505] border-t border-white/5 py-16 px-6 md:px-12" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-serif text-2xl font-medium tracking-tight text-primary" data-testid="footer-logo">
                ONPOINT<span className="text-foreground">.</span>
              </span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">
              Authority infrastructure for founder-independent businesses.
            </p>
            <p className="text-xs text-muted-foreground">
              TessaAuthority.com
            </p>
          </div>

          {/* Authority */}
          <div>
            <h4 className="text-xs font-medium tracking-[0.2em] uppercase text-foreground mb-4">
              Authority
            </h4>
            <div className="space-y-3">
              {[
                { name: "Systems", href: "/systems" },
                { name: "Manifesto", href: "/manifesto" },
                { name: "Governance", href: "/governance" },
                { name: "Certification", href: "/certification" },
              ].map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Access */}
          <div>
            <h4 className="text-xs font-medium tracking-[0.2em] uppercase text-foreground mb-4">
              Access
            </h4>
            <div className="space-y-3">
              {[
                { name: "Operator Application", href: "/operator-application" },
                { name: "Investor Access", href: "/investor-access" },
                { name: "Authority Review", href: "/authority-review" },
              ].map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-medium tracking-[0.2em] uppercase text-foreground mb-4">
              Legal
            </h4>
            <div className="space-y-3">
              {[
                { name: "Privacy Policy", href: "/privacy" },
                { name: "Terms of Service", href: "/terms" },
                { name: "Corporate Info", href: "/legal" },
              ].map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Corporate Disclaimer */}
        <div className="mt-12 pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
            <div className="flex items-start gap-3">
              <Building2 className="h-4 w-4 text-muted-foreground flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-xs text-foreground font-medium">
                  OnPoint Authority Systems, Inc.
                </p>
                <p className="text-xs text-muted-foreground">
                  A Delaware Corporation • Governance & Licensing Framework
                </p>
              </div>
            </div>
            <p className="text-xs text-muted-foreground">
              © {new Date().getFullYear()} All rights reserved.
            </p>
          </div>
        </div>

        {/* Tagline */}
        <div className="mt-8 text-center">
          <p className="text-xs text-muted-foreground italic">
            Authority is engineered, not marketed.
          </p>
        </div>
      </div>
    </footer>
  );
};
